import { Locale } from './language'

/**
 * Gets checkout URL local storage key.
 */
export const getCheckoutUrlStorageKey = (locale: Locale) =>
  `checkout_url_v2_${locale}`
